import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { Spinner } from 'ui';
import { hasGlobalFeature } from 'selectors';
import ReportingBlock from '../Partials/ReportingBlock';
import ReportingBlockHeader from '../Partials/ReportingBlockHeader';
import ContentsList from './ContentsList';

const Performance = ({ loading, isCertification, features }) => (
  <ReportingBlock>
    <ReportingBlockHeader
      title={
        (!isCertification && t('paths.path_builder.performance_title')) ||
        (isCertification &&
          (features.certifications
            ? t(
                'certifications.certification_builder.performance_title_certification_path',
              )
            : t(
                'certifications.certification_builder.performance_title_certification',
              )))
      }
    />
    {loading ? <Spinner /> : <ContentsList />}
  </ReportingBlock>
);

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  isCertification: !!get('certification')(pathBuilder),
  features: {
    certifications: hasGlobalFeature(state, 'certifications'),
  },
});

export default connect(mapStateToProps)(Performance);
